
export class ScenarioStepParameter {
editable: boolean;
level: number | null;
visible: boolean;
}

